"use client";
import {
  ChartConfig,
  ChartContainer,
  ChartLegend,
  ChartLegendContent,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";
import { UI } from "@/constants";
import { UserType } from "@/types";
import { Bar, BarChart, CartesianGrid, LabelList, XAxis } from "recharts";

const chartConfig = {
  sharedProductsTotal: {
    label: UI.labels.sharedProductsTotal,
    color: "var(--chart-3)",
  },
  productsTotal: {
    label: UI.labels.productsTotal,
    color: "var(--chart-5)",
  },
} satisfies ChartConfig;

const bars = [
  { key: "sharedProductsTotal", color: "var(--color-sharedProductsTotal)" },
  { key: "productsTotal", color: "var(--color-productsTotal)" },
];

type UsersTopChartProps = {
  users: UserType[];
  usersLength: number;
};

export const UsersTopChart = ({ users, usersLength }: UsersTopChartProps) => {
  if (!usersLength) return;
  const limitedUsers = users.slice(0, Number(UI.options.size[1]));
  const maxName = limitedUsers.length > 10 ? 7 : 20;

  return (
    <ChartContainer config={chartConfig} className="chart-container pb-8 border-b">
      <BarChart accessibilityLayer data={limitedUsers} margin={{ top: 24 }}>
        <CartesianGrid vertical={false} />
        <XAxis
          dataKey="name"
          tickLine={false}
          axisLine={false}
          tickMargin={8}
          minTickGap={32}
          tickFormatter={value => value.slice(0, maxName)}
        />
        <ChartTooltip content={<ChartTooltipContent className="w-52" indicator="line" />} />
        <ChartLegend content={<ChartLegendContent />} />
        {bars.map(({ key, color }) => (
          <Bar key={key} dataKey={key} fill={color} radius={4}>
            <LabelList position="top" offset={12} className="fill-foreground" fontSize={12} />
          </Bar>
        ))}
      </BarChart>
    </ChartContainer>
  );
};
